import { combineReducers } from 'redux';
import { sarsaparillaReducers } from 'sarsaparilla';

import { externalRatingReviewsReducers} from 'ui-rating-review/src/reducers';
import { reducers as permitContentReducers } from 'ui-permit/shared-components/slices/permitContent';
import moduleReducers from '../src/reducers/permit';
import inyoValidationReducers from '../src/reducers/validation';
import sharedReducers from '../src/reducers/shared';

const rootReducer = combineReducers({
  // boundary waters reducers
  inyonwhitney: moduleReducers,
  inyoValidation: inyoValidationReducers,
  permitContent: permitContentReducers,
  // Ratings and review reducers
  ratingReviews: externalRatingReviewsReducers,
  shared: sharedReducers,
  ...sarsaparillaReducers
});

export default rootReducer;
